import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { apigetCurrentaffairById,getAdjacentCurrentAffairs } from "../../services/apiCurrentAffairs/apicurrentaffairs";

export default function CurrentAffairsDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [currentAffair, setCurrentAffair] = useState(null);
    const [adjacentPosts, setAdjacentPosts] = useState({ prev: null, next: null });
    const [error, setError] = useState(null);

    useEffect(() => {
        const handleContextMenu = (e) => {
          e.preventDefault();
        };
    
        const handleKeyDown = (e) => {
          if ((e.ctrlKey || e.metaKey) && e.key === 'c') {
            e.preventDefault();
          }
        };
    
        document.addEventListener('contextmenu', handleContextMenu);
        document.addEventListener('keydown', handleKeyDown);
    
        return () => {
          document.removeEventListener('contextmenu', handleContextMenu);
          document.removeEventListener('keydown', handleKeyDown);
        };
      }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await apigetCurrentaffairById(id);
                setCurrentAffair(response);
                
                const adjacentResponse = await getAdjacentCurrentAffairs(id);
                setAdjacentPosts(adjacentResponse);
                
                setError(null);
            } catch (err) {
                console.error("Error fetching data:", err);
                setError("Failed to load the current affair. Please try again later.");
                setCurrentAffair(null);
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const navigateToPost = (postId) => {
        if (postId) {
            navigate(`/current-affairs-detail/${postId}`);
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <p className="text-lg">Loading current affair...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-4 text-center">
                <div className="p-4 mb-4 text-red-700 bg-red-100 rounded-lg">
                    {error}
                </div>
                <Link to="/current-affairs" className="text-blue-600 hover:underline">
                    Back to Current Affairs
                </Link>
            </div>
        );
    }

    if (!currentAffair) {
        return (
            <div className="p-4 text-center">
                <div className="p-4 mb-4 text-yellow-700 bg-yellow-100 rounded-lg">
                    Current affair not found
                </div>
                <Link to="/current-affairs" className="text-blue-600 hover:underline">
                    Back to Current Affairs
                </Link>
            </div>
        );
    }

    return (
        <div className="max-w-4xl p-4 mx-auto">
            <Link to="/current-affairs" className="inline-block mb-4 text-blue-600 hover:underline">
                &larr; Back to Current Affairs
            </Link>

            <div className="p-6 bg-white rounded-lg shadow-md">
                <div className="mb-4">
                    <h1 className="text-2xl font-bold text-gray-800">{currentAffair.Title}</h1>
                    <div className="flex flex-wrap gap-2 mt-2">
                        <span className="text-sm text-gray-500">{formatDate(currentAffair.createdAt)}</span>
                        <span className="px-2 py-1 text-sm text-blue-800 bg-blue-100 rounded">
                            {currentAffair.Category}
                        </span>
                        <span className="px-2 py-1 text-sm text-green-800 bg-green-100 rounded">
                            {currentAffair.Current_Affair_Type}
                        </span>
                    </div>
                </div>

                <div className="mt-6 prose max-w-none">
                    <div dangerouslySetInnerHTML={{ __html: currentAffair.Content }} />
                </div>
                
                <div className="flex justify-between pt-4 mt-8 border-t border-gray-200">
                    <button 
                        onClick={() => navigateToPost(adjacentPosts.prev?._id)}
                        disabled={!adjacentPosts.prev}
                        className={`px-4 py-2 rounded-md flex items-center ${
                            adjacentPosts.prev 
                                ? 'bg-regal-blue text-white hover:bg-gradient-to-l hover:from-regal-blue hover:to-regal-yellow' 
                                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        {adjacentPosts.prev ? 'Previous Post' : 'No Previous Post'}
                    </button>
                    
                    <button 
                        onClick={() => navigateToPost(adjacentPosts.next?._id)}
                        disabled={!adjacentPosts.next}
                        className={`px-4 py-2 rounded-md flex items-center ${
                            adjacentPosts.next 
                                ? 'bg-regal-blue text-white hover:bg-gradient-to-l hover:from-regal-yellow hover:to-regal-blue' 
                                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                    >
                        {adjacentPosts.next ? 'Next Post' : 'No Next Post'}
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
}